import React, { useEffect } from 'react';
import { Card } from "tea-component";
import { useIntl } from 'umi';
import classnames from 'classnames';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import Abnormal from '@home/components/Abnormal';
import './index.scss';

export interface ISummaryCard {
  className?: string;
  style?: React.CSSProperties;
  titleEn: React.ReactNode;
  titleCn: React.ReactNode;
  subtitle?: string;
  data: any;
  dataKey: string;
  gameName: string;
  changeData: (key: string, value: string) => void;
}

const SummaryCard = (props: ISummaryCard) => {
  const {
    className,
    style,
    titleEn,
    titleCn,
    data,
    dataKey,
    gameName,
    changeData,
  } = props;

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const summaryItem = data?.[dataKey]?.data?.[0] || {};
  const { summary_en, summary_cn, version } = summaryItem || {};

  const gameVersion = `${gameName}${version ? ` - ${version}` : ''}`;
  useEffect(() => {
    changeData('gameVersion', gameVersion);
  }, [gameVersion]);


  return (
    <Abnormal
      classNames="dbd-benchmark-summary-card-abnormal"
      isLoading={data?.[dataKey]?.loading}
      isError={!!data?.[dataKey]?.errorMsg}
      isNoData={!data?.[dataKey]?.data}
      component={
        <Card
          className={classnames('dbd-benchmark-summary-card', className)}
          style={style}
        >
          <Card.Body
            title={
              <div className="dbd-benchmark-summary-card-title">
                {getLanguage(isEn, titleEn, titleCn)}
                {/* <div className="dbd-benchmark-summary-card-subtitle">
                  {gameName}{version ? ` - ${version}` : ''}
                </div> */}
              </div>
            }
          >
            <div className="dbd-benchmark-summary-content" dangerouslySetInnerHTML={{ __html: getLanguage(isEn, summary_en, summary_cn) || ''}}>
              
            </div>
          </Card.Body>
        </Card>
      }
    />
  );
};

export default SummaryCard;

